import { render, staticRenderFns } from "./SystemMessageEdit.vue?vue&type=template&id=266a2794&scoped=true&"
import script from "./SystemMessageEdit.vue?vue&type=script&lang=js&"
export * from "./SystemMessageEdit.vue?vue&type=script&lang=js&"
import style0 from "./SystemMessageEdit.vue?vue&type=style&index=0&id=266a2794&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266a2794",
  null
  
)

export default component.exports